/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum TimelineEntryImportance {
    Unspecified = '0',
    Overdue = 1,
    Escalated = 2,
}
